module.exports = __webpack_public_path__ + "static/media/Spewpa_gaussian2.91d5e019.png";